{
    "locale": "nl-NL",
    "General": {
        "OrText": "Of",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Ga naar My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Maak een nieuw account aan",
        "ButtonText_SignInToYourAccount": "Log in op je account",
        "ButtonText_StartInterviewWithoutSigningUp": "Start interview zonder registreren",
        "ButtonText_StartInterviewWithoutSigningIn": "Start interview zonder inloggen",
        "Navlink_Dashboard": "Dashboard",
        "Navlink_MyInterviews": "Mijn interviews",
        "Navlink_LearnWithHubert": "Leer met Hubert",
        "Navlink_HelpCenter": "Helpcenter",
        "MyProfile": "Mijn profiel",
        "LogOut": "Uitloggen"
    },
    "Login": {
        "MainTitle": "Bekijk de resultaten van je Hubert-interview",
        "Subtitle": "Log in om resultaten te zien, feedback te krijgen, advies te lezen en meer.",
        "LoginTitle": "Log in op je Hubert-account",
        "Label_Email": "E-mailadres",
        "Label_Password": "Wachtwoord",
        "ButtonText_SignIn": "Inloggen",
        "ButtonText_ForgotPassword": "Wachtwoord vergeten?",
        "ButtonText_ContinueWithGoogle": "Doorgaan met Google",
        "OrSeparator": "Of",
        "Error_Email_Required": "E-mailadres is verplicht.",
        "Error_Email_Invalid": "Voer een geldig e-mailadres in.",
        "Error_Password_Required": "Wachtwoord is verplicht.",
        "Error_Use_Same_Email_As_Interview": "Gebruik hetzelfde e-mailadres als tijdens het interview."
    },
    "Registration": {
        "MainTitle": "Bekijk de resultaten van je Hubert-interview",
        "Subtitle": "Meld je aan om resultaten te zien, feedback te krijgen, advies te lezen en meer.",
        "RegistrationTitle": "Maak Hubert-account aan",
        "BenefitsBox_Title": "Je kunt",
        "BenefitsBox_Point1": "Toegang krijgen tot je interviewgeschiedenis",
        "BenefitsBox_Point2": "Feedback krijgen op je interviews",
        "BenefitsBox_Point3": "Antwoorden hergebruiken in nieuwe interviews",
        "BenefitsBox_Point4": "Interviewadvies krijgen",
        "BenefitsBox_Point5": "Carrièregidsen lezen",
        "BenefitsBox_Point6": "En nog veel meer",
        "Label_FirstName": "Voornaam",
        "Label_LastName": "Achternaam",
        "Label_Email": "E-mailadres",
        "Label_Password": "Wachtwoord",
        "Label_PhoneNumber": "Telefoonnummer",
        "Label_TermsOfService": "Ik accepteer het",
        "Label_TermsOfServiceLink": "Privacybeleid en de Algemene Voorwaarden",
        "Placeholder_CountryCode": "Selecteer landcode",
        "Placeholder_PhoneNumber": "Bijv.0612345678",
        "HelpText_Password": "Wachtwoord moet minimaal 6 tekens lang zijn.",
        "ButtonText_SignUp": "Aanmelden",
        "ButtonText_SignUpWithGoogle": "Aanmelden met Google",
        "OrSeparator": "Of",
        "Error_FirstName_Required": "Voornaam is verplicht.",
        "Error_LastName_Required": "Achternaam is verplicht.",
        "Error_Email_Required": "E-mailadres is verplicht.",
        "Error_Email_Invalid": "Voer een geldig e-mailadres in.",
        "Error_Email_Exists": "E-mailadres is al in gebruik.",
        "Error_Password_Required": "Wachtwoord is verplicht.",
        "Error_Password_6_Characters": "Je wachtwoord moet minimaal 6 tekens lang zijn.",
        "Error_PhoneNumber_Required": "Telefoonnummer is verplicht.",
        "Error_PhoneNumber_Invalid": "Telefoonnummer is ongeldig.",
        "Error_PrivacyPolicyCheck_Required": "Privacybeleid en Algemene Voorwaarden moeten worden geaccepteerd."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Om het interview te doen, moet je de voorwaarden voor het gebruik van Hubert accepteren. Vink simpelweg het vakje aan om door te gaan.",
        "Subtitle_AfterInterviewCompleted": "Meld je aan om resultaten te zien, feedback te krijgen, advies te lezen en meer.",
        "PrivacyPolicyText": "Door op aanmelden te klikken ga je akkoord met het",
        "PrivacyPolicyLink": "Privacybeleid en de Algemene Voorwaarden",
        "ButtonText_SignUp": "Aanmelden & naar interview",
        "ButtonText_SignUpNormal": "Aanmelden",
        "ButtonText_SignInInstead": "Klik hier om in plaats daarvan in te loggen"
    },
    "LoginInviteEmail": {
        "Subtitle": "Log in om resultaten te zien, feedback te krijgen, advies te lezen en meer."
    },
    "AppMessages": {
        "internal-server-error": "Er is een onverwachte fout opgetreden.",
        "invalid-credentials": "Ongeldige inloggegevens. Probeer het opnieuw.",
        "user-not-found": "Ongeldige inloggegevens. Probeer het opnieuw.",
        "account-not-found": "Ongeldig account. Probeer het opnieuw.",
        "verify-email-title": "Verifieer je e-mailadres",
        "verify-email-subtitle": "Controleer je e-mail om je account te verifiëren.",
        "email-not-verified-title": "E-mailadres niet geverifieerd",
        "email-not-verified-subtitle": "Controleer je e-mail om je account te verifiëren.",
        "verifying-email-title": "E-mail verifiëren",
        "verifying-email-subtitle": "Even geduld...",
        "sign-in-title": "Inloggen",
        "sign-in-subtitle": "Even geduld...",
        "server-error": "Er is iets misgegaan.",
        "hubert-user-exists": "Account bestaat al.",
        "account-exists": "Account bestaat al.",
        "email-verified": "Je e-mailadres is geverifieerd.",
        "email-is-taken": "E-mailadres is al in gebruik.",
        "re-enter-password": "Gebruik je wachtwoord om in te loggen",
        "password-reset": "Je wachtwoord is gewijzigd.",
        "re-enter-new-password": "Gebruik je nieuwe wachtwoord om in te loggen",
        "invalid-invitation": "Ongeldige uitnodiging.",
        "invalid-code": "Ongeldige verificatiecode.",
        "email-already-verified": "E-mailadres is al geverifieerd.",
        "email-mismatch-title": "E-mailadres komt niet overeen",
        "email-mismatch-subtitle": "Gebruik hetzelfde e-mailadres dat je hebt gebruikt voor je sollicitatie."
    },
    "TransitionPage": {
        "loading-title": "Laden...",
        "loading-subtitle": "Gegevens voorbereiden...",
        "logout-title": "Laden...",
        "logout-subtitle": "Je wordt uitgelogd..."
    },
    "ImpersonationPage": {
        "loading-title": "Laden...",
        "loading-subtitle": "Gegevens voorbereiden..."
    },
    "ProcessInvitation": {
        "loading-title": "Laden...",
        "loading-subtitle": "Even geduld, we laden je interview.",
        "InvitationNotFound": "We kunnen je interview niet vinden.",
        "InvitationExpired": "De link naar dit interview is verlopen.",
        "InvitationExpired_Description1": "Open het interview via.",
        "InvitationExpired_Description2": "of neem contact op met je recruiter.",
        "InvitationInvalid": "De link naar deze uitnodiging is ongeldig.",
        "InterviewCompleted": "Dit interview is al afgerond."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Mijn interviews",
            "TableHead_Employer": "Werkgever",
            "TableHead_Job": "Functie",
            "TableHead_Status": "Status",
            "TableHead_ApplicationDate": "Sollicitatiedatum",
            "TableBody_StartInterview": "Het interview is niet afgerond. Klik hier om te starten of verder te gaan.",
            "TableBody_NotScored": "Het interview is afgerond. Resultaten zijn binnenkort beschikbaar.",
            "TableBody_Details": "Klik hier om interviewresultaten en meer te zien.",
            "ApplicationDate_Invited": "Uitgenodigd",
            "ApplicationDate_MinuteAgo": "minuut geleden",
            "ApplicationDate_MinutesAgo": "minuten geleden",
            "ApplicationDate_HourAgo": "uur geleden",
            "ApplicationDate_HoursAgo": "uren geleden",
            "ApplicationDate_DayAgo": "dag geleden",
            "ApplicationDate_DaysAgo": "dagen geleden",
            "ButtonText_SeeAllInterviews": "Bekijk alle interviews",
            "ButtonText_Details": "Details",
            "ButtonText_StartInterview": "Ga naar interview",
            "ButtonText_NotScored": "In afwachting van resultaten",
            "NoInterviews_Message": "Er zijn geen eerdere of geplande interviews voor jou."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Er zijn momenteel geen vacatures. Kijk later nog eens."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Mijn carrière",
            "Subtitle": "Selecteer een interview om de beoordeling en je vooruitzichten te zien.",
            "MostRecentInterview": "Meest recente interview",
            "ToDo": "Te doen",
            "NoOngoingInterviews_Title": "Je hebt geen nieuwe interviewuitnodigingen.",
            "NoOngoingInterviews_Subtitle": "Nieuwe Hubert-interviews verschijnen hier zodra ze door recruiters zijn ingepland.",
            "NoRecentInterviews_Title": "Er zijn geen eerdere interviews voor jou gevonden.",
            "NoRecentInterviews_Subtitle": "Zodra je wordt uitgenodigd voor een interview, verschijnt het hieronder.",
            "ButtonText_StartInterview": "Ga naar interview",
            "ButtonText_NotScored": "In afwachting van resultaten",
            "ButtonText_Details": "Details"
        },
        "LearnWithHubert": {
            "Title": "Leer met Hubert",
            "Subtitle": "Krijg advies over hoe je je interviewvaardigheden en werkprestaties kunt verbeteren.",
            "PickedForMe": "Laatste artikelen",
            "ButtonText_SeeAllArticles": "Bekijk alle artikelen"
        },
        "HubertTip": {
            "Title": "Hubert-tip",
            "Subtitle": "Doe interviews sneller",
            "Description": "Solliciteer je voor een vergelijkbare rol waarvoor je al een Hubert-interview hebt gedaan? Je kunt je eerdere antwoorden hergebruiken en tijd besparen.",
            "ButtonText_ReadMoreTips": "Lees meer tips"
        },
        "NewCandidateModalPopup": {
            "Title": "Je bent er helemaal klaar voor!",
            "DescriptionLine1": "Je account is nu gereed.",
            "DescriptionLine2": "Beheer je interviews en profiel. Bekijk je resultaten, krijg feedback en leer meer over het doen van interviews.",
            "ButtonText_LetsGo": "Laten we beginnen"
        },
        "InterviewCompletedModal": {
            "Title": "Goed gedaan!",
            "Subtitle": "Je hebt je interview afgerond.",
            "Description": "Recruiters zullen alle sollicitaties bekijken en feedback geven via e-mail of telefoon zodra ze nieuws hebben.",
            "ButtonText_Continue": "Doorgaan"
        },
        "LatestJobPostings": {
            "Title": "Laatste vacatures",
            "Subtitle": "Ontdek andere vacatures van Hubert-partners die onlangs zijn geplaatst."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Mijn interviews",
        "MyInterviewsSection_Subtitle": "Selecteer een interview om de beoordeling en je carrièremogelijkheden te zien.",
        "MyInterviewsSection_ToDo": "Te doen"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Bekijk alle interviews",
        "InterviewNotFound_Title": "Interview niet toegankelijk",
        "InterviewNotFound_Description": "Je probeert toegang te krijgen tot interviewdetails die niet aan je account zijn gekoppeld.",
        "ButtonText_GoToAllInterviews": "Ga naar Mijn interviews",
        "InterviewDetails": {
            "Title": "Interviewdetails",
            "ForRole": "Voor rol",
            "InterviewCompletedOn": "Interview afgerond op {{date}} om {{time}}"
        },
        "MyResult": {
            "Title": "Mijn resultaat",
            "Subtitle": "Beoordeelde match",
            "ButtonText_LearnMore": "Bekijk hoe je antwoorden worden beoordeeld",
            "GotPotential_Title": "Veel potentieel, vereiste ontbreekt",
            "GotPotential_Description": "Je antwoorden tonen veel potentieel voor dit type rol. Op basis van dit interview voldoe je echter mogelijk niet aan een of meer vereisten voor deze specifieke baan. Dit kan invloed hebben op de vervolgstappen, afhankelijk van de behoeften van de recruiter en het aantal kandidaten. Als je niet wordt uitgenodigd voor de volgende ronde, betekent dit niet dat je geen goede kandidaat bent. Vaak gaat het om specifieke vereisten voor de rol. Bekijk de onderstaande kansen en tips.",
            "GotPotential_DescriptionSecondary": "De beoordeling van Hubert is adviserend. De recruiter neemt de uiteindelijke beslissing en andere factoren, zoals het aantal kandidaten, kunnen ook van invloed zijn.",
            "GreatMatch_Title": "Sterke match",
            "GreatMatch_Description": "Je antwoorden sluiten goed aan bij wat recruiters doorgaans zoeken voor deze rol, en je voldoet aan de eisen. Uitstekend werk. De recruiter zal alle kandidaten bekijken en de vervolgstappen bepalen.",
            "GreatMatch_DescriptionSecondary": "De beoordeling van Hubert is adviserend. De recruiter neemt de uiteindelijke beslissing en andere factoren, zoals het aantal kandidaten, kunnen ook van invloed zijn. Als je niet wordt uitgenodigd voor de volgende ronde, betekent dit niet dat je geen goede kandidaat bent. Vaak gaat het om specifieke vereisten voor de rol. Bekijk de onderstaande kansen en tips.",
            "OkMatch_Title": "Gekwalificeerd, voeg meer impact toe",
            "OkMatch_Description": "Je voldoet aan de functie-eisen. Om extra op te vallen, kunnen je antwoorden baat hebben bij meer duidelijkheid en specificiteit. Bekijk je antwoorden hieronder om te zien waar het toevoegen van een concreet voorbeeld of resultaat je score kan verhogen.",
            "OkMatch_DescriptionSecondary": "De beoordeling van Hubert is adviserend. De recruiter neemt de uiteindelijke beslissing en andere factoren, zoals het aantal kandidaten, kunnen ook van invloed zijn.",
            "NotClearMatch_Title": "Misschien niet de juiste match op dit moment",
            "NotClearMatch_Description": "Op basis van dit interview sluiten je antwoorden mogelijk minder goed aan bij wat de recruiter zoekt, of voldoe je niet aan een of meer eisen. Als je wilt verbeteren, begin dan met de vragen hieronder. Kleine aanpassingen, meer details en duidelijke resultaten kunnen de volgende keer een groot verschil maken.",
            "NotClearMatch_DescriptionSecondary": "De beoordeling van Hubert is adviserend. De recruiter neemt de uiteindelijke beslissing en andere factoren, zoals het aantal kandidaten, kunnen ook van invloed zijn."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Professionele ervaringen, motivaties en competenties",
            "QualifyingRequirements": "Kwalificatie-eisen voor deze specifieke baan",
            "NotQualified_Title": "Ruimte voor verbetering",
            "NotQualified_Description": "Je antwoorden waren mogelijk minder specifiek of resultaatgericht dan de recruiter verwacht voor deze rol. Kijk hieronder naar gemarkeerde plekken waar het toevoegen van een concreet voorbeeld, acties die je hebt ondernomen of een duidelijk resultaat je antwoord kan versterken.",
            "GreatResults_Title": "Sterke antwoorden",
            "GreatResults_Description": "Je antwoorden geven aan dat je goed past bij dit type rol en je kwam duidelijk over. Als een vraag kan worden verbeterd, zie je deze hieronder gemarkeerd.",
            "MeetingRequirements_Title": "Voldoet aan eisen",
            "MeetingRequirements_Description": "Je antwoorden geven aan dat je voldoet aan de kwalificatie-eisen die de recruiter voor deze baan heeft gesteld. Een goede basis.",
            "NotAllExpectationsMet_Title": "Een of meer vereisten ontbreken",
            "NotAllExpectationsMet_Description": "Op basis van je antwoorden voldoe je mogelijk niet aan een of meer kwalificatie-eisen voor deze specifieke baan, zoals certificaten, rijbewijzen, opleidingsniveau of jaren ervaring.",
            "ButtonText_FindOutPossibleReasons": "Bekijk details"
        },
        "ScriptFromInterview": {
            "Title": "Lees je volledige interview",
            "ButtonText_SeeWholeTranscript": "Lees interview",
            "ButtonText_DeleteInterview": "Verwijder interview",
            "Loading_Title": "Laden...",
            "Loading_Subtitle": "Even geduld, we laden je interviewtranscript."
        },
        "HowToImproveAtInterviews": {
            "Title": "Hoe je interviews kunt verbeteren",
            "Subtitle_Questions": "Hier zijn enkele vragen waarbij je antwoord mogelijk verbeterd kan worden.",
            "Subtitle_NoQuestions": "Er zijn geen specifieke antwoorden gemarkeerd. Hier zijn de beste manieren om impact toe te voegen voor deze rol.",
            "GreatMatch_Questions_Description": "Zelfs als sterke match kunnen sommige antwoorden nog worden versterkt. Als we er hebben gevonden, zie je ze hieronder. Volg de instructies vóór elke vraag. Beschrijf bij een situatie de situatie, wat je deed en het resultaat. Vermijd hele korte antwoorden. Streef naar duidelijke en concrete beschrijvingen, net zoals in een persoonlijk gesprek.",
            "GreatMatch_NoQuestions_Description": "Je hebt de vragen goed beantwoord. Uitstekend werk.",
            "OkMatch_Questions_Description": "Hieronder vind je vragen waarbij je antwoord verbeterd kan worden. Volg de instructies vóór elke vraag. Beschrijf bij een situatie de situatie, wat je deed en het resultaat. Vermijd hele korte antwoorden. Streef naar duidelijke en concrete beschrijvingen, net zoals in een persoonlijk gesprek.",
            "OkMatch_NoQuestions_Description": "Je antwoorden waren solide, maar deze rol kan competitief zijn. Dat betekent dat zelfs goede antwoorden in de middenmoot kunnen belanden.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Streef de volgende keer naar duidelijkheid en impact. Begin met het resultaat, voeg een echt voorbeeld toe en houd het beknopt, meestal 3 tot 6 zinnen. Wees specifiek over wat je deed, hoe je het deed en wat erdoor veranderde.",
            "GotPotential_Questions_Description": "Zelfs als je een sterke match lijkt voor dit type baan, kunnen sommige antwoorden nog worden versterkt. Als we er hebben gevonden, zie je ze hieronder. Volg de instructies vóór elke vraag. Beschrijf bij een situatie de situatie, wat je deed en het resultaat. Vermijd hele korte antwoorden. Streef naar duidelijke en concrete beschrijvingen, net zoals in een persoonlijk gesprek.",
            "GotPotential_NoQuestions_Description": "We hebben geen antwoorden gevonden die grote verbetering nodig hebben wat betreft professionele competenties en motivaties. Je lijkt goed te hebben geantwoord op die onderwerpen.",
            "NotClearMatch_Questions_Description": "Hieronder vind je vragen waarbij je antwoord verbeterd kan worden. Volg de instructies vóór elke vraag. Beschrijf bij een situatie de situatie, wat je deed en het resultaat. Vermijd hele korte antwoorden. Streef naar duidelijke en concrete beschrijvingen, net zoals in een persoonlijk gesprek.",
            "NotClearMatch_NoQuestions_Description": "We hebben geen enkel 'slecht' antwoord gevonden. Het gaat meer om de algehele aansluiting bij wat deze rol nodig heeft. Als de concurrentie sterk is, kunnen kleine verschillen tellen.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Focus voor je volgende interview op concreetheid. Kies één voorbeeld per vraag, leg je acties uit en deel het resultaat. Kort en specifiek wint het meestal van lang en algemeen.",
            "Alert_WantMoreAdvice": "Wil je meer advies over hoe je goed kunt presteren bij een Hubert-interview?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Bekijk ons artikel met algemeen advies"
        },
        "SimilarOffers": {
            "Title": "Vergelijkbare aanbiedingen"
        },
        "HowHubertScoresInterviews": {
            "Title": "Hoe beoordeelt Hubert interviews?",
            "Description": "Hieronder volgt een korte beschrijving van hoe Hubert interviewantwoorden beoordeelt. We hebben ook een sectie Wervingsproces toegevoegd om uit te leggen hoe de vervolgstappen eruitzien.",
            "Tabs_PossibleOutcomes": "Mogelijke uitkomsten",
            "Tabs_RecruitmentProcess": "Wervingsproces",
            "AssessedMatch_Title": "Beoordeelde match",
            "AssessedMatch_Description": "Hubert beoordeelt hoe je antwoorden overkomen in vergelijking met wat recruiters doorgaans zoeken voor deze rol. Samen met de functie-eisen zie je een van de onderstaande uitkomsten.",
            "AssessedMatch_DescriptionSecondary": "De beoordeling van Hubert is adviserend. De recruiter neemt de uiteindelijke beslissing en andere factoren, zoals het aantal kandidaten, kunnen ook van invloed zijn.",
            "GreatMatch_Title": "Sterke match",
            "GreatMatch_Description": "Je antwoorden sluiten goed aan bij wat recruiters zoeken, en je voldoet aan de eisen. Uitstekend werk. De recruiter zal de sollicitaties bekijken en de vervolgstappen bepalen.",
            "GotPotential_Title": "Veel potentieel, vereiste ontbreekt",
            "GotPotential_Description": "Je antwoorden tonen veel potentieel. Op basis van dit interview voldoe je echter mogelijk niet aan een of meer vereisten. Dit kan invloed hebben op de vervolgstappen.",
            "OkMatch_Title": "Gekwalificeerd, voeg meer impact toe",
            "OkMatch_Description": "Je voldoet aan de eisen. Om op te vallen, hebben je antwoorden mogelijk meer duidelijkheid en specificiteit nodig. Gebruik de feedback om je voorbeelden in de toekomst te versterken.",
            "NotClearMatch_Title": "Misschien niet de juiste match op dit moment",
            "NotClearMatch_Description": "Op basis van dit interview sluiten je antwoorden mogelijk minder goed aan bij wat de recruiter zoekt, en voldoe je mogelijk niet aan alle eisen. Bekijk je antwoorden om te zien waar je meer duidelijkheid en voorbeelden kunt toevoegen.",
            "ProfessionalExperiences_Title": "Professionele ervaringen, motivaties en competenties",
            "ProfessionalExperiences_Description": "Dit zijn vragen over je eerdere ervaringen, je motivatie en relevante competenties. Recruiters bepalen welke vragen worden gebruikt.",
            "GreatResults_Title": "Sterke antwoorden",
            "GreatResults_Description": "Je antwoorden geven aan dat je goed past bij dit type rol en duidelijk communiceerde. Als een vraag kan worden verbeterd, wordt deze gemarkeerd.",
            "NotQualified_Title": "Ruimte voor verbetering",
            "NotQualified_Description": "Je antwoorden waren mogelijk minder specifiek of resultaatgericht dan verwacht. Kijk naar gemarkeerde plekken waar een concreet voorbeeld of resultaat je antwoord kan versterken.",
            "QualifyingRequirements_Title": "Basis- of kwalificatie-eisen",
            "QualifyingRequirements_Description": "Dit zijn vragen die de recruiter heeft ingesteld als vereisten, zoals een certificaat, rijbewijs of een bepaald niveau van ervaring.",
            "MeetingRequirements_Title": "Voldoet aan eisen",
            "MeetingRequirements_Description": "Je antwoorden geven aan dat je voldoet aan de kwalificatie-eisen. Een goede basis.",
            "NotAllExpectationsMet_Title": "Een of meer vereisten ontbreken",
            "NotAllExpectationsMet_Description": "Op basis van je antwoorden voldoe je mogelijk niet aan een of meer kwalificatie-eisen voor deze specifieke baan.",
            "RecruitmentProcess_Title": "Wervingsproces",
            "RecruitmentProcess_Description": "Hubert wordt vaak gebruikt als eerste stap. Het stelt iedereen in staat een interview te doen en zichzelf te presenteren. Omdat de vragen voor iedereen gelijk zijn, is het proces consistenter. Hubert gebruikt geen informatie zoals leeftijd, geslacht of uiterlijk, wat onbewuste vooroordelen vermindert.",
            "EventOne_Title": "Je wordt geïnterviewd door Hubert",
            "EventOne_Description": "Je doet het interview waar en wanneer het jou uitkomt. Er is geen tijdslimiet en je kunt op elk moment pauzeren.",
            "EventTwo_Title": "Je interview wordt beoordeeld",
            "EventTwo_Description": "Hubert beoordeelt je antwoorden met moderne technologie. Zodra de beoordeling klaar is, zijn de resultaten zichtbaar in My Hubert en voor de recruiter.",
            "EventThree_Title": "Recruiter selecteert kandidaten",
            "EventThree_Description": "Recruiters zien wanneer er een nieuw resultaat beschikbaar is. Ze bekijken je antwoorden en de beoordeling van Hubert. Op basis van het advies en hun eigen oordeel bepalen ze de volgende stap, bijvoorbeeld een telefoongesprek, een test of een laatste gesprek. In sommige gevallen wachten recruiters met een volgende stap tot ze meer sollicitaties hebben ontvangen. Als andere kandidaten op dit moment beter passen, kan het zijn dat je niet doorgaat naar de volgende stap.",
            "ButtonText_Close": "Sluiten"
        }
    },
    "MyProfile": {
        "Title": "Mijn profiel",
        "MyDetails": {
            "Title": "Mijn gegevens",
            "Label_FirstName": "Voornaam",
            "Label_LastName": "Achternaam",
            "Label_Email": "E-mailadres",
            "Label_PhoneNumber": "Telefoonnummer",
            "ButtonText_UpdateDetails": "Gegevens bijwerken",
            "Error_FirstName_Required": "Voornaam is verplicht.",
            "Error_LastName_Required": "Achternaam is verplicht.",
            "Error_Email_Required": "E-mailadres is verplicht.",
            "Error_Email_Invalid": "Voer een geldig e-mailadres in.",
            "Error_PhoneNumber_Invalid": "Telefoonnummer is ongeldig.",
            "Success_Details_Updated": "Profiel bijgewerkt."
        },
        "ChangePassword": {
            "Title": "Wachtwoord wijzigen",
            "Set_Password_Title": "Maak wachtwoord aan",
            "Label_CurrentPassword": "Huidig wachtwoord",
            "Label_NewPassword": "Nieuw wachtwoord",
            "Label_RepeatNewPassword": "Herhaal nieuw wachtwoord",
            "Alert_SignInAgain": "Log opnieuw in om je wachtwoord in te stellen.",
            "ButtonText_UpdatePassword": "Wachtwoord bijwerken",
            "ButtonText_SetPassword": "Wachtwoord instellen",
            "ButtonText_SignInAgain": "Opnieuw inloggen",
            "Error_CurrentPassword_Required": "Huidig wachtwoord is verplicht.",
            "Error_CurrentPassword_DoesntMatch": "Wachtwoord komt niet overeen met huidig wachtwoord.",
            "Error_NewPassword_Required": "Nieuw wachtwoord is verplicht.",
            "Error_NewPassword_6_Characters": "Je nieuwe wachtwoord moet minimaal 6 tekens lang zijn.",
            "Error_RepeatNewPassword_Required": "Herhaal nieuw wachtwoord is verplicht.",
            "Error_RepeatNewPassword_DoesntMatch": "Wachtwoord komt niet overeen met nieuw wachtwoord.",
            "Success_Password_Changed": "Wachtwoord bijgewerkt.",
            "Error_Invalid_CurrentPassword": "Ongeldig huidig wachtwoord."
        },
        "NotificationPreferences": {
            "Title": "Notificatievoorkeuren",
            "Label_ReceiveUpdatesToggle": "Ik wil updates van Hubert ontvangen.",
            "Label_ReceiveUpdatesToggleHelpText": "Je ontvangt carrièregidsen, interviewtips en meer."
        },
        "AccountRemoval": {
            "Title": "Account verwijderen",
            "ButtonText_RemoveMyAccount": "Verwijder mijn account"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Hallo",
        "Subtitle": "Je staat op het punt je sollicitatiegesprek te beginnen.",
        "TipBox_Title": "Hier zijn een paar tips om je te helpen slagen.",
        "TipBox_Tip1": "Doe het interview op een rustige plek waar je je kunt concentreren.",
        "TipBox_Tip2": "Antwoord op een computer met toetsenbord (tenzij je comfortabel bent met veel typen op je mobiel).",
        "TipBox_Tip3": "Wees zo specifiek en gedetailleerd mogelijk. Hubert en recruiters willen je graag goed leren kennen.",
        "TipBox_Tip4": "Neem de tijd die je nodig hebt. Er zijn geen tijdslimieten.",
        "TipBox_Tip5": "Je kunt op elk moment pauzeren en verdergaan waar je was gebleven.",
        "TipBox_Tip6": "Wees jezelf en benader het Hubert-interview net zo serieus als een persoonlijk gesprek.",
        "CheckAdviceArticle_Text1": "Als je meer tips wilt om te slagen voor het interview, bekijk dan dit",
        "CheckAdviceArticle_Text2": "artikel",
        "CheckAdviceArticle_Text3": "met goed advies.",
        "ReadyToGetStarted": "Ben je klaar om te beginnen?",
        "ORSeparator_Text": "Of",
        "ButtonText_StartInterviewNow": "Start interview nu",
        "ButtonText_SetReminder": "Niet klaar, stel een herinnering in",
        "PrivacyPolicyText": "Door op start interview te klikken ga je akkoord met het",
        "PrivacyPolicyLink": "Privacybeleid en de Algemene Voorwaarden"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Goed gedaan!",
        "CompletedAlert_Subtitle": "Je hebt je interview afgerond.",
        "CompletedAlert_Description": "Recruiters zullen alle sollicitaties bekijken en feedback geven via e-mail of telefoon zodra ze een update hebben.",
        "InterviewNotCompleted": "Dit interview is niet afgerond."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Helpcenter",
            "Subtitle": "Vind antwoorden op de meest gestelde vragen over Hubert.",
            "Label_Search": "zoek veelgestelde vragen",
            "ButtonText_Search": "Zoeken"
        },
        "FAQSection": {
            "Tabs_All": "Alles",
            "Tabs_AboutHubertInterview": "Over Hubert-interview",
            "Tabs_TechnicalSupport": "Technische ondersteuning"
        },
        "StillHaveQuestion": {
            "Title": "Heb je nog een vraag?",
            "Description": "We helpen je graag.",
            "DropUsAEmail": "E-mail ons op hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Kan ik mijn interview via de telefoon doen?",
                    "a": "Hubert werkt momenteel alleen via chat. Als je een medische aandoening hebt die dit verhindert, neem dan contact op met het bedrijf."
                },
                {
                    "q": "Kan ik het interview in een andere taal doen?",
                    "a": "Bij sommige interviews kun je een taal kiezen. Als deze optie ontbreekt, is de taal waarschijnlijk een vereiste. Neem voor vragen contact op met het bedrijf."
                },
                {
                    "q": "Word ik afgestraft voor korte antwoorden?",
                    "a": "Nee, zolang je de vragen passend beantwoordt. Details helpen echter vaak."
                },
                {
                    "q": "Kan ik mijn antwoorden hergebruiken?",
                    "a": "Ja, als je bent ingelogd bij My Hubert en solliciteert op een vergelijkbare rol."
                },
                {
                    "q": "Leest een mens mijn interview?",
                    "a": "Ja, onze klanten wordt gevraagd interviews handmatig te controleren."
                },
                {
                    "q": "Ik heb het interview gedaan, wat nu?",
                    "a": "De resultaten worden naar de recruiter gestuurd. Zij bekijken je antwoorden en de beoordeling en beslissen over de volgende stap (bellen, test, eindgesprek)."
                },
                {
                    "q": "Ik heb een vraag over het proces, met wie neem ik contact op?",
                    "a": "Neem contact op met het bedrijf waar je hebt gesolliciteerd."
                },
                {
                    "q": "Hoe voorkomen jullie vooroordelen?",
                    "a": "Hubert is consistenter dan een mens en kent geen leeftijd, geslacht of uiterlijk, wat onbewuste vooroordelen vermindert."
                },
                {
                    "q": "Kan ik door een mens worden geïnterviewd?",
                    "a": "Neem contact op met het bedrijf om dit te vragen."
                },
                {
                    "q": "Is Hubert een mens?",
                    "a": "Nee, Hubert is een computersysteem."
                },
                {
                    "q": "Kan ik mijn antwoorden achteraf wijzigen?",
                    "a": "Nee, net als in een echt gesprek kun je antwoorden niet opnieuw doen."
                },
                {
                    "q": "Hoe slaag ik voor het Hubert-interview?",
                    "a": "Lees de vragen goed, volg de instructies, geef echte voorbeelden en wees eerlijk."
                },
                {
                    "q": "Ik heb een baan nodig, wie moet ik contacteren?",
                    "a": "Neem contact op met het bedrijf waar je hebt gesolliciteerd."
                },
                {
                    "q": "Ik heb niets gehoord na het interview. Wat nu?",
                    "a": "Recruiters beslissen over vervolgstappen. Als andere kandidaten op dit moment beter passen, kan het zijn dat je niet doorgaat naar de volgende stap. Neem contact op met de recruiter als je een update wilt."
                },
                {
                    "q": "Ik heb veel ervaring maar kreeg de baan niet. Waarom?",
                    "a": "De concurrentie kan groot zijn. Vraag het bedrijf om feedback of bekijk My Hubert voor advies."
                },
                {
                    "q": "Hoe lang duurt het interview?",
                    "a": "Tussen de 10 en 25 minuten. Haast je niet."
                },
                {
                    "q": "Waar kan ik lezen over gegevensverwerking?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Waarom zie ik mijn vorige interviews niet?",
                    "a": "Zorg dat je hetzelfde e-mailadres gebruikt als bij je sollicitatie (ook bij Google-login)."
                },
                {
                    "q": "Waarom heb ik geen e-mail ontvangen?",
                    "a": "Check je spam. Of maak een My Hubert-account aan met je sollicitatie-e-mail om de link te vinden."
                },
                {
                    "q": "Ik vind de link niet in mijn e-mail.",
                    "a": "Check je spam. Of log in op My Hubert en ga naar 'Mijn interviews'."
                },
                {
                    "q": "Werkt het interview op mobiel?",
                    "a": "Ja, maar een computer typt vaak prettiger."
                },
                {
                    "q": "Het interview werkt niet, wat nu?",
                    "a": "Stuur een e-mail naar hubert@hubert.ai."
                },
                {
                    "q": "Ik wil mijn account verwijderen, wat nu?",
                    "a": "Stuur een e-mail naar hubert@hubert.ai."
                },
                {
                    "q": "Het interview werd onderbroken, hoe ga ik terug?",
                    "a": "Klik op de link in de e-mail of log in op My Hubert."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Leer met Hubert",
            "Subtitle": "Ontdek hoe je je kansen vergroot en beter presteert.",
            "Label_Search": "zoek gidsen",
            "ButtonText_Search": "Zoeken"
        },
        "TabSelector": {
            "MyFeed": "Mijn feed",
            "InterviewGuides": "Interviewgidsen",
            "CareerGuides": "Carrièregidsen"
        },
        "NewestOnTheFeed": "Nieuwste",
        "PickedForMe": "Laatste artikelen",
        "InterviewGuides": "Interviewgidsen",
        "CareerGuides": "Carrièregidsen"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Terug naar alle artikelen"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Wachtwoord resetten",
        "ResetLinkAlert_Subtitle": "Klik op de link in je e-mail om een nieuw wachtwoord in te stellen.",
        "PasswordNotSetAlert_Message": "Geen wachtwoord ingesteld, log in met ",
        "ResetYourPassword": {
            "MainTitle": "Bekijk de resultaten van je Hubert-interview",
            "Subtitle": "Log in om resultaten te zien, feedback te krijgen en meer.",
            "FormSectionTitle": "Reset je wachtwoord",
            "Label_NewPassword": "Nieuw wachtwoord",
            "Label_ConfirmNewPassword": "Bevestig nieuw wachtwoord",
            "Error_NewPassword_Required": "Voer een nieuw wachtwoord in.",
            "Error_Password_6_Characters": "Je nieuwe wachtwoord moet minimaal 6 tekens lang zijn.",
            "Error_ConfirmNewPassword_Required": "Bevestig je nieuwe wachtwoord.",
            "Error_ConfirmNewPassword_NotMatch": "Wachtwoorden komen niet overeen.",
            "Error_MalformedResetUrl": "Ongeldige beveiligingscode. Probeer het opnieuw.",
            "Error_ResetPasswordFailed": "Probleem bij het resetten. Probeer het opnieuw.",
            "Error_WeakPassword": "Wachtwoord moet minimaal 6 tekens bevatten.",
            "Error_InvalidCode_Title": "Je aanvraag is verlopen of ongeldig.",
            "Error_InvalidCode_Subtitle": "Probeer je wachtwoord opnieuw te resetten.",
            "ButtonText_SetNewPassword": "Instellen & inloggen",
            "ButtonText_RememberYourPassword": "Wachtwoord herinnerd?",
            "ButtonText_SignInInstead": "In plaats daarvan inloggen"
        }
    },
    "PageNotFound": {
        "Title": "Pagina niet gevonden",
        "Description": "We kunnen de pagina die je zoekt niet vinden.",
        "ButtonText_GoToDashboard": "Ga naar Dashboard",
        "ButtonText_GoToLogin": "Ga naar Inloggen"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Het hergebruiken van antwoorden is voor dit interview nog niet beschikbaar. We verwachten dit binnenkort, maar je kunt het interview nu al doen.",
        "DescriptionLine2": "Ga naar het interview door op de knop hieronder te klikken.",
        "ButtonText_TakeMeToTheInterview": "Ga naar interview"
    },
    "UnsubscribeFromEmails": {
        "Title": "Weet je het zeker?",
        "Subtitle": "Je ontvangt geen e-mails meer over deze vacature:",
        "SelectTheReason": "Selecteer een reden.",
        "ReasonText1": "Ik heb ander werk gevonden.",
        "ReasonText2": "Ik ben niet meer geïnteresseerd.",
        "ReasonText3": "Anders",
        "ButtonText_Unsubscribe": "Uitschrijven",
        "Placeholder_YourReason": "Je reden",
        "Success_Title": "Je bent succesvol uitgeschreven.",
        "Loading": "Laden...",
        "Error_YourReason_Required": "Voer een reden in.",
        "Error_ServerIssue": "Uitschrijven mislukt door serverfout."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Probeer opnieuw"
    },
    "Outreach": {
        "CandidateNotFound": "Kandidaat niet gevonden",
        "CandidateNotFoundDesc": "We konden de interviewdetails die u zoekt niet vinden.",
        "InterviewEnded": "Interview beëindigd",
        "InterviewEndedDesc1": "Deze interviewsessie is beëindigd of is niet langer beschikbaar.",
        "InterviewEndedDesc2": "Bedankt voor uw tijd. Als u vragen heeft, neem dan contact op met het wervingsteam.",
        "ReadyTitle": "Klaar voor je interview, {{firstName}}?",
        "InvitationDesc": "Hubert nodigt je namens {{companyName}} uit voor een chat-gebaseerd interview dat ongeveer 1-2 minuten duurt.",
        "Button_StartChat": "Start chat-interview",
        "CancelNotice": "Als u hier begint, wordt de geplande oproep voor deze rol geannuleerd.",
        "PreferNotToContinue": "Liever niet verdergaan?",
        "DeclineLabel": "Ik heb geen interesse in deze rol. Bel of bericht me niet meer over deze positie.",
        "Button_ConfirmAndDecline": "Bevestigen en afwijzen",
        "Processing": "Verwerken...",
        "Toast_DeclineSuccess": "Interview succesvol afgewezen",
        "Toast_CancelVoiceInfo": "Spraakinterview geannuleerd. Functie volgt binnenkort.",
        "Toast_CancelError": "Annuleren van interview mislukt. Probeer het opnieuw.",
        "Footer_WithdrawConsent": "U kunt uw toestemming op elk moment intrekken. Lees meer in het ",
        "Footer_PrivacyPolicySuffix": "privacybeleid van ",
        "Footer_And": " en het ",
        "Footer_HubertPrivacyLink": "privacybeleid en de algemene voorwaarden van Hubert",
        "Chat_InterviewWith": "Interview met {{companyName}}",
        "Chat_StatusConnected": "Verbonden",
        "Chat_StatusError": "Fout",
        "Chat_StatusDisconnected": "Verbinding verbroken",
        "Chat_StatusConnecting": "Verbinden...",
        "Chat_ReadyToStart": "Klaar om het interview te beginnen?",
        "Chat_ButtonStart": "Start interview",
        "Chat_SayHello": "Zeg hallo om het gesprek te beginnen.",
        "Chat_EmptyState": "Stuur een bericht om het interview te beginnen.",
        "Chat_SelectLanguage": "Kies je taal",
        "Chat_Placeholder": "Typ je bericht...",
        "Chat_ButtonSend": "Verzenden",
        "Chat_ButtonBack": "Terug",
        "LoadingCandidateDetails": "Kandidaatdetails laden...",
        "FetchingCandidateDetails": "Kandidaatdetails ophalen...",
        "Chat_StatusReady": "Wachten op verbinding...",
        "Chat_ForbiddenError": "Dit chat-interview is niet langer beschikbaar.",
        "Chat_GeneralError": "Starten van de chat mislukt. Probeer het later opnieuw.",
        "Chat_SelectUiLanguage": "Taal van het menu",
        "Chat_InterviewTitle": "Sollicitatiegesprek"
    }
}
